module.exports = __webpack_public_path__ + "img/logo_white_transparent_background.573b9729.png";